// src/components/studentPortal/Community.jsx
// Section 7 of the Student Portal. Reuses the existing Community page
// (src/pages/comunity.jsx, default export FilmCommunityPage) rendered
// inline instead of navigating away. hideNav=true skips its own <Nav/> so
// it doesn't stack above this portal's sidebar layout - additive,
// backward-compatible prop (default false), the standalone /Comunity route
// is unaffected.
import React from 'react';
import FilmCommunityPage from '../../pages/comunity';

const Community = () => <FilmCommunityPage hideNav />;

export default Community;
